import React from 'react';
import { useStepBuilder } from '../../../../../../components/StepBuilder/useStepBuilder';
import { MdCheck, MdRadioButtonUnchecked } from 'react-icons/md';

const Progress = ({ stepInfo, stepNames }) => {
  const { current, total } = useStepBuilder();

  const steps = Array.from({ length: total }, (_, i) => i);

  return (
    <div className="progress-meter-wrapper">
      <ul className="progress-meter">
        {steps.map((index) => {
          let stepClassName = "progress-meter__element";
          const markerContent = (index < current - 1) ? <MdCheck /> : <MdRadioButtonUnchecked />;

          if (index === current - 1)
            stepClassName += ' progress-meter__element--active';
          if (index < current - 1)
            stepClassName += ' progress-meter__element--completed';

          return (
            <li className={stepClassName} key={index}>
              <span className="progress-meter__marker">{markerContent}</span>
              <span className="progress-text">
                <h4 className="progress-title">{stepNames[index]}</h4>
                {stepInfo[index]}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Progress;
